import { ApiItem } from '@ibe/api';
import AnalyticsBase from './AnalyticsBase';

class ItemDetailEvent extends AnalyticsBase {
  item: ApiItem;
}

export default ItemDetailEvent;
